export const MULTI_CURRENCY_HELP_LINK =
  'https://help.factorialhr.com/finance/multi-currency-support-in-financial-workspace/version/1'
